import './index.css'
import DragDropMatchingGame, { type DragDropMatchingConfig } from './DragDropMatchingGame'
import { mountCrucialReact } from './crucialReactMount'
import { renderCrucialRoot } from './renderCrucialRoot'
import { type ThemeMode, withHostTheme } from './themeHandler'

const ThemedMatchingGame = withHostTheme(
  ({ config, theme }: { config: DragDropMatchingConfig; theme: ThemeMode }) => (
    <DragDropMatchingGame config={config} theme={theme} />
  ),
)

mountCrucialReact<DragDropMatchingConfig>('DragDropMatchingGame', (root, config) => {
  if (!Array.isArray(config.pairs) || config.pairs.length === 0) return

  renderCrucialRoot(
    root,
    'DragDropMatchingGame',
    <ThemedMatchingGame config={config} />,
  )
})
